import React from "react";

import "./PrintTemplate.css";
import PrintTemplateA4 from "./PrintTemplateA4";

interface Props{
    toningData:any;
}
export class PrintTemplateA4Printer extends React.PureComponent<Props> {
  render() {
    return (
      <PrintTemplateA4 toningData={this.props.toningData} />
    );
  }
}
